<template>
  <div class="all">
    <div class="nav">
      <div class="navItem">
        <label></label>
        <div>
          <label :style="fir ? 'color:#003e79;font-weight: bold;' : ''"
            >01</label
          >
          <label :style="fir ? 'color:#003e79;font-weight: bold;' : ''"
            >受邀嘉宾注册</label
          >
        </div>
      </div>
      <div class="navItem">
        <label
          class="label-trans"
          :style="second ? 'color:#003e79;font-weight: bold;' : ''"
          >>>>>>>></label
        >
        <div>
          <label :style="second ? 'color:#003e79;font-weight: bold;' : ''"
            >02</label
          >
          <label :style="second ? 'color:#003e79;font-weight: bold;' : ''"
            >注册信息填写</label
          >
        </div>
      </div>
      <div class="navItem">
        <label
          class="label-trans"
          :style="thir ? 'color:#003e79;font-weight: bold;' : ''"
          >>>>>>>></label
        >
        <div>
          <label :style="thir ? 'color:#003e79;font-weight: bold;' : ''"
            >03</label
          >
          <label :style="thir ? 'color:#003e79;font-weight: bold;' : ''"
            >注册信息确认</label
          >
        </div>
      </div>
      <div class="navItem">
        <label
          class="label-trans"
          :style="forth ? 'color:#003e79;font-weight: bold;' : ''"
          >>>>>>>></label
        >
        <div>
          <label :style="forth ? 'color:#003e79;font-weight: bold;' : ''"
            >04</label
          >
          <label :style="forth ? 'color:#003e79;font-weight: bold;' : ''"
            >完成</label
          >
        </div>
      </div>
    </div>

    <div class="center" v-if="fir">
      <div class="small-window" style="margin-top:71px;">
        <ul class="tab">
          <li class="li-active">
            添加账户（帮他人注册）
          </li>
        </ul>
        <div class="matter">
          <div class="matter-contain">
            <div class="item">
              <p>邀请码填写*</p>
              <input v-model="formData.inviteCode" placeholder="邀请码" autocomplete="off" />
            </div>
          </div>
          <button class="regist-solid-btn" @click="next">下一步</button>
        </div>
      </div>
    </div>

    <div class="inviteCenter ipts" v-if="second">
      <div class="title">注册信息（*项为必填项）</div>
      <div class="list">
        <div class="centerItem">
          <label class="name">姓名*</label>
          <input
            placeholder="请输入您的姓名"
            class="txtin inputRequired"
            v-model="formData.guestName"
            autocomplete="off"
          />
        </div>
        <div class="centerItem">
          <label class="name">身份证号*</label>
          <input
            placeholder="请输入您的身份证号"
            class="txtin inputRequired"
            v-model="formData.certNo"
            autocomplete="off"
          />
        </div>
      </div>
    </div>

    <div class="inviteCenter" v-if="thir">
        <div class="title">注册信息（*项为必填项）</div>
      <div class="list">
        <div class="centerItem">
          <label class="name">姓名*</label>
          <label class="look">{{ formData.guestName }}</label>
        </div>
        <div class="centerItem">
            <label class="name">身份证号*</label>
            <label class="look">{{ formData.certNo }}</label>
        </div>
      </div>
    </div>

    <div class="center" v-if="forth">
      <div class="small-window" style="margin-top: 71px">
        <ul class="tab">
          <li class="li-active">添加账户（帮他人注册）</li>
        </ul>
        <div class="matter">
          <div class="suc-remind">
            <img src="@/static/img/jj_gou.png" />
            <p>成功添加用户</p>
            <p style="font-size: 16px">
              <span>{{ jumpT }}</span
              >s跳转到个人中心…
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="foo">
      <div v-if="second">
        <button class="leftBtn" @click="pre">上一步</button>
        <button class="rightBtn" @click="next">下一步</button>
      </div>
      <div v-if="thir">
        <button class="leftBtn" @click="pre">返回修改</button>
        <button class="rightBtn" @click="submit">确认提交</button>
      </div>
    </div>
  </div>
</template>

<script>
import { chkInviteCode, helpRegist } from "@/api/newUser";

export default {
  data() {
    return {
      mainId: '',
      jumpT: 3,
      formData: {
        inviteCode: '',
        guestName: '',
        certType: '01',
        certNo: ''
    },
      fir: true,
      second: false,
      thir: false,
      forth: false
    };
  },
  created() {
    this.mainId = this.$session.get("cmm").mainId
  },
  methods: {
    pre() {
      if (this.second) {
        this.fir = true;
        this.second = false;
      }
      if (this.thir) {
        this.second = true;
        this.thir = false;
      }
    },
    // 下一页
    next() {
      if (this.fir) {
        if(!this.formData.inviteCode) {
          this.$message('请输入正确的邀请码');
          return;
        }
        chkInviteCode({
          mainId: this.mainId,
          inviteCode: this.formData.inviteCode
        }).then(res => {
          if(res.code == 200 && res.data) {
            this.fir = false;
            this.second = true;
          }
        })
      } else {
        if (!this.checkForm()) {
            return;
        }
        this.second = false;
        this.thir = true;
      }
    },
    submit() {
      helpRegist(Object.assign({mainId: this.mainId},this.formData)).then(res => {
        this.thir = false;
        this.forth = true;
        setInterval(() => {
            this.jumpT--;
            if (this.jumpT == 0) {
                this.$router.push("/userIndex");
            }
        }, 1000);
      })
    },
    // 表单校验
    checkForm: function() {
        var data = $(".ipts").serialize();
        var array = data.split("&");
        for (var i = 0; i < array.length; i++) {
            var arr = array[i].split("=");
            var len = $(".inputRequired").length;
            for (var j = 0; j < len; j++) {
                const value = $(".inputRequired")
                    .eq(j)
                    .val();
                if (value == null || value == "") {
                    this.$message("该项不能为空~");
                    $(".inputRequired")
                    .eq(j)
                    .focus();
                    return false;
                }
            }
        }
        return true;
    }
  }
};
</script>

<style src="../../static/css/regist.css" scoped></style>
